import { createContext, useRef } from 'react'
import { InjectedConnector } from '@web3-react/injected-connector'
import { getRpcUrl } from 'modules/blockChain/utils/getRpcUrls'
import { isClientSide } from 'shared/utils/isClientSide'
import LedgerHQConnector from 'web3-ledgerhq-connector'
import { WalletConnectConnector } from '@web3-react/walletconnect-connector'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { Chains } from 'modules/blockChain/chains'

export type WalletConnectorsValue = {
  metamask: InjectedConnector
  walletconnect: WalletConnectConnector
  ledger: LedgerHQConnector
}

export const walletConnectorsContext = createContext(
  {} as WalletConnectorsValue,
)

type Props = {
  children?: React.ReactNode
}

export function WalletConnectorsProvider({ children }: Props) {
  const { chainId: currentChainId } = useWeb3()
  const { current } = useRef({
    isInited: false,
    connectors: {} as WalletConnectorsValue,
  })

  if (!current.isInited && isClientSide()) {
    const rpcUrl = getRpcUrl(currentChainId)
    const mainnetRpcUrl = getRpcUrl(Chains.Mainnet)

    current.connectors.metamask = new InjectedConnector({})

    current.connectors.walletconnect = new WalletConnectConnector({
      chainId: currentChainId,
      rpc: { [currentChainId]: rpcUrl, [Chains.Mainnet]: mainnetRpcUrl },
      qrcode: true,
      qrcodeModalOptions: {
        desktopLinks: [
          'ledger',
          // 'tokenary',
          // 'wallet',
          // 'wallet 3',
          // 'secuX',
          // 'ambire',
          // 'wallet3',
          // 'apolloX',
          // 'zerion',
          // 'sequence',
          // 'punkWallet',
          // 'kryptoGO',
          // 'nft',
          // 'riceWallet',
          // 'vision',
          // 'keyring',
        ],
        mobileLinks: [
          // 'rainbow',
          'metamask',
          // 'argent',
          'trust',
          // 'imtoken',
          // 'pillar',
        ],
      },
    })

    current.connectors.ledger = new LedgerHQConnector({
      chainId: currentChainId,
      url: rpcUrl,
    })

    current.isInited = true
  }

  return (
    <walletConnectorsContext.Provider
      value={current.connectors}
      children={children}
    />
  )
}
